/**
 * useScrollReveal —— 滚动条显隐三态（docs/ui_scroller §3/§4）
 * 滚动进行中短暂显示（debounce 400ms 后隐藏）；悬浮容器时由 CSS :hover 处理（不经 JS）。
 * 返回 { scrolling, onScroll }，配合 *Scrolling 类切换 thumb 颜色。
 */
import { useCallback, useEffect, useRef, useState } from 'react'

export function useScrollReveal(debounceMs = 400) {
  const [scrolling, setScrolling] = useState(false)
  const timer = useRef<number | undefined>(undefined)

  const onScroll = useCallback(() => {
    setScrolling(true)
    if (timer.current !== undefined) window.clearTimeout(timer.current)
    timer.current = window.setTimeout(() => setScrolling(false), debounceMs)
  }, [debounceMs])

  useEffect(
    () => () => {
      if (timer.current !== undefined) window.clearTimeout(timer.current)
    },
    [],
  )

  return { scrolling, onScroll }
}
